/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Error_Certification_Badge_Name_TakenInputs */

const vi_error_certification_badge_name_taken = /** @type {(inputs: Error_Certification_Badge_Name_TakenInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Đã có logo tên "${i?.name}". Đặt tên khác.`)
};

/**

* @param {Error_Certification_Badge_Name_TakenInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_certification_badge_name_taken = /** @type {((inputs: Error_Certification_Badge_Name_TakenInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Certification_Badge_Name_TakenInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_certification_badge_name_taken(inputs)
});